import React from 'react';
import Text from '../../../elements/Text';
import { Button } from '../../../elements';
import Theme from '../../../Theme';
export var getIndexForMapeo = function (itemSelected) {
    var isCollaboratorStretch = !!itemSelected.operator_id;
    return !isCollaboratorStretch ? itemSelected.id : String(itemSelected.id) + '_' + itemSelected.operator_id;
};
var SettingService = function (_a) {
    var selected = _a.selected, hoursSelected = _a.hoursSelected, idaVueltaSelected = _a.idaVueltaSelected, handleHorasIdaSelected = _a.handleHorasIdaSelected, handleIdaVuelta = _a.handleIdaVuelta;
    return (React.createElement(React.Fragment, null, selected.map(function (itemSelected) {
        var index = getIndexForMapeo(itemSelected);
        return (React.createElement("div", { key: itemSelected.name, style: { display: 'flex', alignItems: 'center', minHeight: '30px', border: '1px solid black', marginTop: '2px', marginBottom: '2px' } },
            React.createElement(Text, { style: { paddingLeft: '10px', paddingRight: '10px', marginTop: 1, marginBottom: 1 } }, itemSelected.name),
            React.createElement("div", null,
                React.createElement("div", { style: { marginTop: '10px', marginBottom: '10px' } }, itemSelected.horasIda.map(function (horaIda) {
                    var enabled = false;
                    if (hoursSelected[index]) {
                        enabled = !!hoursSelected[index].find(function (hourSelected) { return hourSelected.id === horaIda.id; });
                    }
                    return (React.createElement("div", { style: {
                            display: 'inline-block',
                            marginLeft: 5,
                            marginRight: 5
                        }, key: horaIda.id },
                        React.createElement(Button, { style: buttonStyle(enabled), onClick: function () { handleHorasIdaSelected(horaIda, itemSelected); } },
                            React.createElement(Text, { center: true, color: enabled ? 'white' : 'black', style: { marginTop: 1, marginBottom: 1, paddingLeft: '5px', paddingRight: '5px' } }, "".concat(horaIda.hours > 9 ? horaIda.hours : '0' + horaIda.hours, ":").concat(horaIda.minutes > 9 ? horaIda.minutes : '0' + horaIda.minutes)))));
                })),
                itemSelected.horasIda && itemSelected.vuelta &&
                    React.createElement("div", { style: { backgroundColor: Theme.color.hairline, height: '1px', marginTop: '5px', marginBottom: '5px' } }),
                itemSelected.vuelta &&
                    React.createElement("div", { style: { display: 'inline-block', marginTop: '5px', marginBottom: '10px' } },
                        React.createElement("div", { style: {
                                display: 'inline-block',
                                marginLeft: 5,
                                marginRight: 5
                            } },
                            React.createElement(Button, { style: buttonStyle(!idaVueltaSelected[index]), onClick: function () { handleIdaVuelta(false, itemSelected); } },
                                React.createElement(Text, { style: { marginTop: 1, marginBottom: 1, color: !idaVueltaSelected[index] ? 'white' : 'black', paddingLeft: '5px', paddingRight: '5px' } }, 'ida'))),
                        React.createElement("div", { style: {
                                display: 'inline-block',
                                marginLeft: 5,
                                marginRight: 5
                            } },
                            React.createElement(Button, { style: buttonStyle(idaVueltaSelected[index]), onClick: function () { handleIdaVuelta(true, itemSelected); } },
                                React.createElement(Text, { style: { marginTop: 1, marginBottom: 1, color: idaVueltaSelected[index] ? 'white' : 'black', minWidth: '30px', paddingLeft: '5px', paddingRight: '5px' } }, 'ida-vuelta')))))));
    })));
};
var buttonStyle = function (enabled) {
    return {
        backgroundColor: enabled ? 'green' : 'whitesmoke',
        border: '1 solid red',
        borderStyle: 'solid',
        borderColor: 'red',
        borderWidth: '1px',
        borderRadius: 5
    };
};
export default SettingService;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Packets/container/SettingService.tsx
// module id = 1557
// module chunks = 0